// This file is extracted to trick eslint into supporting dynamic imports
// Can be added back to accordion when eslint is upgraded
// Or removed completely if the profile setting page is removed

var registerSortingListener = function() {
  $('#sorting_order').change(function(e) {
    // Submit the form whenever the order is changed to anything other than custom
    if(e.target.value !== "3") {
      $('form#sorting').submit();
    }
  });
};

export const setupEditMode = function () {
  var sortingMenu = $('#sorting_order');
  sortingMenu.show();
  registerSortingListener();
  // js scrollpane adds custom html which breaks the sortable option for the slideshelf. Adding it manually after jsscroll pane is added.
  $('.jspPane').addClass('sortable');
  import('../vendor/jquery-ui.js').then(function () {
    //Using the jQuery UI's sortable
    $('.sortable').sortable({
      delay: '100',
      update: function (event, ui) {
        //If sorting has been used and dropdown is not custom - change it to custom
        if (sortingMenu.val() !== '3') {
          sortingMenu.val('3');
          $('.j-show_more').hide();
        }
      },
    });
    $('.sortable').disableSelection();
  });
};
